import React from 'react';
import { Plane, BookOpen, FileText, Star } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <FileText className="w-5 h-5 text-slate-300" data-id="element-304" />,
    text: '+300 recursos didácticos'
  }, {
    icon: <BookOpen className="w-5 h-5 text-slate-300" data-id="element-305" />,
    text: '8 Módulos completos'
  }, {
    icon: <Plane className="w-5 h-5 text-slate-300" data-id="element-306" />,
    text: '4 tomos + 4 bonos'
  }, {
    icon: <Star className="w-5 h-5 text-slate-300 fill-slate-300" data-id="element-307" />,
    text: '4.9/5 calificación'
  }];
  return <div className="bg-slate-900 border-y border-slate-800 py-6" data-id="element-308">
      <div className="container mx-auto px-4" data-id="element-309">
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-4 md:justify-between items-center max-w-5xl mx-auto" data-id="element-310">
          {stats.map((stat, i) => <div key={i} className="flex items-center gap-2 font-medium text-slate-200" data-id="element-311">
              {stat.icon}
              <span data-id="element-312">{stat.text}</span>
            </div>)}
        </div>
      </div>
    </div>;
}